<div class="container-fluid p-1 d-flex flex-column">
  <div class="col-md-12">

    <div class="row" style="padding-right: 8px;">
      <div class="col-md-9 align-items-center">
        <aside class="user-info-wrapper" style="border:none;">
          <div class="user-info">
            <div class="user-avatar ">
              <!-- <edit-avatar (change)="selectFile($event)">
                          </edit-avatar> -->
              <img class="d-block mx-auto" [src]="url ?? 'assets/img/login-logo.png'" alt="User">
              <!-- <img class="d-block mx-auto" [src]="url?url:'assets/img/lord-ayyappa.png'" alt="User"> -->
              <!-- <aside class="user-info-wrapper" style="border:none;">
                  <div class="user-info">
                    <div class="user-avatar">
                      <edit-avatar (deleteImg)="delete($event)" (change)="selectFile($event)">
                        </edit-avatar>
                      <img [src]="url?url:'assets/img/lord-ayyappa.png'" alt="User">

                    </div>
                  </div>
                </aside> -->
            </div>
          </div>
        </aside>
      </div>
      <!-- </div>
    <div class="row"> offset-md-4-->
      <div class="col-md-3 pe-4">
        <div class="row">
          <div class="col-md-6">&nbsp;</div>
          <div class="col-md-6 align-self-end">
            <app-radio-button #mal labelName="മലയാളം" size="16" value="malayalam" [(ngModel)]="language"
              (change)="chooseLang($event)" style="font-size: 20px;"></app-radio-button>
          </div>
          <div class="col-md-6">&nbsp;</div>
          <div class="col-md-6 align-self-end">
            <app-radio-button #mal labelName="தமிழ்" size="16" value="tamil" [(ngModel)]="language"
              (change)="chooseLang($event)"></app-radio-button>
          </div>
          <div class="col-md-6">&nbsp;</div>
          <div class="col-md-6 align-self-end">
            <app-radio-button #mal labelName="ಕನ್ನಡ" size="16" value="kannada" [(ngModel)]="language"
              (change)="chooseLang($event)"></app-radio-button>
          </div>
          <div class="col-md-6">&nbsp;</div>
          <div class="col-md-6 ">
            <app-radio-button #eng labelName="English" size="20" value="english" [(ngModel)]="language"
              (change)="chooseLang($event)"></app-radio-button>
          </div>
        </div>
        <div class="d-flex flex-column" style="padding-top: calc(30vh);">
          <!-- R48: server-status panel - the circular progress sits ABOVE the
               LOG IN block while the API is checked/started (see server-status.ts) -->
          <div class="srv-status" [ngClass]="'srv-' + serverStatus" role="status">
            <span class="srv-ring" *ngIf="serverStatus !== 'up'"></span>
            <span class="srv-dot" *ngIf="serverStatus === 'up'"></span>
            <span class="srv-text">{{ serverStatusMessage | translate }}</span>
          </div>
          <div class="toolbar-section" id="account">
            <ul class="nav nav-tabs nav-justified" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" href="#login" data-bs-toggle="tab" role="tab">{{'LOG IN'|translate}}</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane fade show active" id="login" role="tabpanel">
                <form autocomplete="off" autocomplete="off" [formGroup]="userForm">
                  <div class="mb-3 " [ngClass]="{ 'has-danger' : (submitted && userForm.get('userName').invalid) }">
                    <div class="input-group" style="display: block;">
                      <input class="form-control form-control-sm" value="temple-3" type="text"
                        style="position: initial; width: 100%;" placeholder="{{'User Name' | translate}}"
                        formControlName="userName" required>
                      <span class="input-group-addon">
                        <i class="material-icons person"></i>
                      </span>
                    </div>
                    <!-- <small class="text-danger" *ngIf="submitted && userForm.get('userName').hasError('required')">
                              {{'User Name' | translate}} {{'is required' |translate}}
                            </small> -->
                    <show-errors *ngIf="submitted" [position]="'left'" [control]="userForm.get('userName')"
                      [field]="'User Name'">
                    </show-errors>
                  </div>

                  <div class="mb-3 " [ngClass]="{ 'has-danger' : (submitted && userForm.get('password').invalid) }">
                    <div class="input-group" style="display: block;">

                      <input class="form-control form-control-sm" type="{{ isPassword ? 'password' : 'text' }}"
                        style="position: initial; width: 100%;" placeholder="{{'Password' | translate}}"
                        formControlName="password" required (keydown)="passwordKeyDown($event)">
                      <span class="input-group-addon">
                        <i class="material-icons lock" (click)="toggleShow()"></i>
                      </span>
                    </div>
                    <!-- <small class="text-danger" value="123" *ngIf="submitted && userForm.get('password').hasError('required')">
                              {{'Password' |translate }} {{'is required' |translate}}
                            </small> -->
                    <show-errors *ngIf="submitted" [position]="'left'" [control]="userForm.get('password')"
                      [field]="'Password'">
                    </show-errors>
                  </div>

                  <div class="mb-3" *ngIf="showTempleDropdown">
                    <div class="input-group" style="display: block;">
                      <select class="form-control form-control-sm" [(ngModel)]="selectedTempleCode"
                        (change)="onTempleChange()" [ngModelOptions]="{standalone: true}"
                        style="position: initial; width: 100%;">
                        <option value="" disabled selected>{{'Select Temple' | translate}}</option>
                        <option *ngFor="let temple of temples" [value]="temple.tuid">{{ temple.name }}</option>
                      </select>
                      <span class="input-group-addon">
                        <i class="material-icons account_balance"></i>
                      </span>
                    </div>
                  </div>

                  <button class="btn btn-primary btn-block btn-sm" (click)="login()" [class.disabled]="loading">{{'LOG
                    IN' | translate}}</button>
                  <!-- <div class="col-sm-10">
                    <a [routerLink]="['/register']" routerLinkActive="router-link-active"
                    style="color: blue; font-size: small; font-weight: bold;">{{'Sign Up' | translate}}</a>
                  </div> -->
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-1"></div> -->
      <!-- </div> -->
    </div>
  </div>


</div>
<!-- </div> -->

<!-- Unified Footer Stack (Fixed Bottom) -->
<div class="glass-bottom-stack fixed-bottom">
  <footer class="glass-footer-info" style="background-color: #404040;">
        <div class="container-fluid" [class.no-padding-mobile]="isMobile">
            <div *ngIf="!isMobile"
                class="d-flex flex-column flex-md-row justify-content-center text-xs align-items-center text-muted mb-0 mt-0 text-center">
                <div class="d-flex flex-column flex-sm-row align-items-center gap-1">
                    <span>© All rights reserved. Made with <i class="bi bi-heart-fill text-danger mx-1 text-xxs"></i> by</span>
                    <a href="http://www.shivamsoftwares.com"
                        class="text-decoration-none text-muted fw-bold hover-underline">Shivam CloudSoft Solutions
                        LLP.</a>
                </div>
                <span (click)="privacy()"
                    class="text-decoration-none text-danger fw-bold hover-underline px-2 py-1 cursor-pointer">Privacy
                    Policy</span>
                <div class="d-flex flex-column flex-sm-row align-items-center">
                    <span>Need Support? Call </span>
                    <span class="text-primary fw-bold">&nbsp;+91 470 2622266 | +91 9947 388 133&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </div>
            </div>
            <!-- Mobile Specific Footer -->
            <div *ngIf="isMobile" class="text-muted text-center py-1" style="font-size: 0.7rem;">
                © <a href="http://www.shivamsoftwares.com"
                        class="text-decoration-none text-muted fw-bold hover-underline">Shivam CloudSoft Solutions
                        LLP.</a>&nbsp;&nbsp;<span class="text-danger" (click)="privacy()">Privacy Policy
                </span> <i class="bi bi-telephone-fill text-primary mx-1"></i> <a href="tel:+91 470 2622266" class="text-decoration-none">+91 470
                    2622266</a>
            </div>
        </div>
    </footer>
</div>